import { createStore } from 'vuex'
import bootstrap from 'bootstrap/dist/js/bootstrap.min.js'
import { auth } from './auth.module'
import { subscription } from './subscription.module'
import dataStore from './dataStore'
import modelStore from './modules/modelStore'
import photo_default from "@/assets/img/profile-picture.png";

export default createStore({
  state: {
    hideConfigButton:
      JSON.parse(localStorage.getItem('hideConfigButton')) || false,
    isPinned: JSON.parse(localStorage.getItem('isPinned')) || false,
    showConfig: JSON.parse(localStorage.getItem('showConfig')) || false,
    isRTL: JSON.parse(localStorage.getItem('isRTL')) || false,
    color: localStorage.getItem('color') || '',
    sidebarType: localStorage.getItem('sidebarType') || 'bg-white',
    darkMode: JSON.parse(localStorage.getItem('darkMode')) || false,
    isNavFixed: JSON.parse(localStorage.getItem('isNavFixed')) || false,
    isAbsolute: JSON.parse(localStorage.getItem('isAbsolute')) || false,
    showNavs: JSON.parse(localStorage.getItem('showNavs')) || true,
    showSidenav: JSON.parse(localStorage.getItem('showSidenav')) || true,
    showNavbar: JSON.parse(localStorage.getItem('showNavbar')) || true,
    showFooter: JSON.parse(localStorage.getItem('showFooter')) || true,
    showMain: JSON.parse(localStorage.getItem('showMain')) || true,
    layout: localStorage.getItem('layout') || 'default',
    bootstrap,
    user: JSON.parse(localStorage.getItem('user')) || {}
  },
  mutations: {
    hideConfigButton(state, value) {
      state.hideConfigButton = value;
      localStorage.setItem('hideConfigButton', JSON.stringify(value));
    },
    toggleConfigurator(state) {
      state.showConfig = !state.showConfig
      localStorage.setItem('showConfig', state.showConfig)
    },
    navbarMinimize(state, value) {
      const sidenav_show = document.querySelector('.g-sidenav-show')
      if (value !== undefined) {
        state.isPinned = value
      } else {
        state.isPinned = !state.isPinned
      }
      localStorage.setItem('isPinned', state.isPinned)

      if (state.isPinned) {
        sidenav_show.classList.remove('g-sidenav-hidden')
        sidenav_show.classList.add('g-sidenav-pinned')
      } else {
        sidenav_show.classList.add('g-sidenav-hidden')
        sidenav_show.classList.remove('g-sidenav-pinned')
      }
    },
    setSidebarType(state, payload) {
      state.sidebarType = payload
      localStorage.setItem('sidebarType', payload)
    },
    navbarFixed(state) {
      state.isNavFixed = !state.isNavFixed
      localStorage.setItem('isNavFixed', state.isNavFixed)
    },
    toggleDefaultLayout(state) {
      state.showNavbar = !state.showNavbar
      state.showSidenav = !state.showSidenav
      state.showFooter = !state.showFooter
      localStorage.setItem('showNavbar', state.showNavbar)
      localStorage.setItem('showSidenav', state.showSidenav)
      localStorage.setItem('showFooter', state.showFooter)
    },
    setDarkMode(state, payload) {
      state.darkMode = payload
      localStorage.setItem('darkMode', payload)
    },
    setUser(state, user) {
      state.user = user
      localStorage.setItem('user', JSON.stringify(user))
    }
  },
  actions: {
    toggleSidebarColor({ commit }, payload) {
      commit('setSidebarType', payload)
    },
    updateUser({ commit, state }, user) {
      const updatedUser = { ...state.user, ...user };
      commit('setUser', updatedUser);
    },
    updateUserPhoto({ commit, state }, photo_url) {
      const updatedUser = { ...state.user, photo_url };
      commit('setUser', updatedUser);
    }
  },
  getters: {
    userName: state => state.user.name || 'Usuario',
    photoUrl: state => state.user.photo_url || photo_default,
    userRoles: state => state.user.roles || [],
    userRoleDescriptions: state => state.user.roles_with_descriptions || []
  },
  modules: {
    auth,
    subscription,
    dataStore,
    modelStore
  }
})
